import type { FC, ReactNode } from 'react'

import { useId } from 'react'
import { cn } from '@/lib/utils'

/* The Washline mark: a car under a water drop on a blue tile. */
export const BrandMark: FC<{ className?: string, title?: string }> = ({ className, title }): ReactNode => {
    const gradientId = `wl-mark-${useId().replace(/[^a-zA-Z0-9_-]/g, '')}`

    return (
        <svg
            viewBox='0 0 48 48'
            className={cn('shrink-0', className)}
            role={title ? 'img' : undefined}
            aria-hidden={title ? undefined : true}
            aria-label={title}
        >
            <defs>
                <linearGradient id={gradientId} x1='0' y1='0' x2='1' y2='1'>
                    <stop offset='0' stopColor='#0b6bd3' />
                    <stop offset='1' stopColor='#13b5d1' />
                </linearGradient>
            </defs>

            <rect width='48' height='48' rx='12' fill={`url(#${gradientId})`} />
            <path d='M24 7.5s-4.6 5.1-4.6 8.2a4.6 4.6 0 0 0 9.2 0c0-3.1-4.6-8.2-4.6-8.2z' fill='#fff' />
            <path d='M13.2 30.2l2.1-5.6a3.2 3.2 0 0 1 3-2.1h11.4a3.2 3.2 0 0 1 3 2.1l2.1 5.6' fill='none' stroke='#fff' strokeWidth='2.6' strokeLinecap='round' strokeLinejoin='round' />
            <rect x='10.5' y='28.6' width='27' height='8.9' rx='3.2' fill='#fff' />
            <circle cx='16.4' cy='33' r='1.75' fill='#0b6bd3' />
            <circle cx='31.6' cy='33' r='1.75' fill='#0b6bd3' />
            <rect x='13' y='36.6' width='4.6' height='3.9' rx='1.3' fill='#fff' />
            <rect x='30.4' y='36.6' width='4.6' height='3.9' rx='1.3' fill='#fff' />
        </svg>
    )
}
